<template>
<div class="loginregister">
    <div class="capture">
      <div class="contain">
        <div class="text">
          <h1>Forgot Password.</h1>
          <p>
            Enter Your Email Address.
          </p>
        </div>
        <div class="form">
          <div class="inputs">
            <div class="input full">
              <label>Email Address</label>
              <input type="email" v-model="email" placeholder="Type here" />
            </div>
            <div class="btns right">
              <transition name="fade-quick">
                <div v-if='status == "submit"'>
                  <button class='btn' @click.prevent="validate()">Reset Password</button>
                  <transition name="fade-quick">
                    <p v-if='error' class='error'>{{error}}</p>
                  </transition>
                </div>
              </transition>
              <transition name="fade-quick">
                <img
                  class="loader"
                  v-if="status == 'loading'"
                  src="@/assets/img/loader.gif"
                />
              </transition>
              <transition name="fade-quick">
                <div class="success" v-if="status == 'success'">
                  <p>
                    An email is on it's way!
                    <span>You can change you're password from there.</span>
                  </p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import { db, auth, functions }  from "../firebaseConfig.js";

export default {
  data() {
    return {
      email: null,
      sendEmail: functions.httpsCallable("sendEmail"),
      status: "submit",
      error: null
    };
  },
  async created() {
    await this.getAffiliates();
  },
  methods: {
    validate(){
      this.error = null;
      this.status = 'loading';
      if (this.email) {
        if (this.email.length) {
          this.sendPasswordResetEmail()
        }
      }else {
        this.error = 'Please enter a valid email'
        this.status = "submit";
      }
    },
    send() {
      if (this.email) {
        this.sendEmail({
          template_name: "covid-19-forgot-password",
          from_email: null,
          to_email: this.email,
          global_merge_vars: [
            {
              name: "link",
              content: "",
            },
          ],
        }).then((res) => {
          let message = res.data;
          Swal.fire(message);
          this.status = "success";
        });
      }
    },
    sendPasswordResetEmail() {
      // this.status = ;
      var emailAddress = this.email;
      var actionCodeSettings = {
        url: this.config.APP_BASE_URL,
        handleCodeInApp: false,
      };

      auth
        .sendPasswordResetEmail(emailAddress, actionCodeSettings)
        .then(() => {
          this.status = "success";
        })
        .catch((error) => {
          console.log("error", error);
          this.error = error.message
          this.status = "submit";
        });
    },
  },
};
</script>

<style lang='scss'>
.capture {
  .contain {
    min-height: 100vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 800px) {
      flex-direction: column;
    }
    & > div {
      width: 45%;
      @media screen and (max-width: 800px) {
        width: 100%;
      }
    }
    .inputs {
      @media screen and (max-width: 800px) {
        width: 100%;
        margin-top: 50px;
      }
      .input {
        // @media screen and (max-width: 800px){
        //   width: 100%;
        // }
      }
      .btns {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        .loader {
          height: 50px;
          filter: brightness(0.96);
        }
        .success {
          font-size: 25px;
          color: #00bf6f;
          font-weight: bold;
          span {
            display: block;
            color: #132628;
            font-size: 16px;
            font-weight: 400;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
